/**
 * Utility functions for the application
 * Based on shadcn/ui patterns
 */

import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines class names with Tailwind CSS merge
 * This allows Tailwind classes to override each other properly
 *
 * @example
 * cn("text-red-500", "text-blue-500") // => "text-blue-500"
 * cn("px-4", conditional && "px-8") // => "px-8" if conditional is true
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
